import styled from "styled-components";

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    max-width: 720px;
    margin: 0 auto;
    padding: 24px 16px 48px;
    gap: 24px;

    @media (max-width: 480px) {
        padding: 16px 12px 32px;
        gap: 16px;
    }
`;

export const Title = styled.h1`
    font-family: "Roboto", "Helvetica", "Arial", sans-serif;
    font-weight: 600;
    font-size: 1.4rem;
    line-height: 1.334;
    margin: 0;
    color: #333;
`;

export const CalendarFrame = styled.div`
    width: 100%;
    background: white;
    border-radius: 16px;
    border: 1px solid #e8e8e8;
    padding: 16px 20px;
    box-sizing: border-box;

    @media (max-width: 480px) {
        padding: 10px;
        border-radius: 12px;
    }

    /* Header dias da semana */
    .fc-col-header-cell {
        background-color: #006a61;
        color: white;
        font-size: 0.8rem;
        font-weight: 500;
        padding: 6px 0;
    }

    /* Botoes de navegacao */
    .fc-button {
        background-color: #006a61 !important;
        border: none !important;
        border-radius: 8px !important;
        font-weight: 500 !important;
        text-transform: capitalize !important;
        box-shadow: none !important;
        padding: 4px 10px !important;
        font-size: 0.85rem !important;

        &:hover {
            background-color: #005a52 !important;
        }
        &:focus {
            box-shadow: none !important;
        }
    }

    .fc-toolbar-title {
        font-size: 1.1rem !important;
        font-weight: 600 !important;
        color: #333;
        text-transform: capitalize;
    }

    .fc-toolbar.fc-header-toolbar {
        gap: 8px;
        margin-bottom: 12px !important;
    }

    .fc-button-group {
        gap: 6px !important;
    }

    /* Celula do dia */
    .fc-daygrid-day-frame {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        min-height: 52px;
        padding: 4px;
        width: 100%;
        box-sizing: border-box;
        cursor: pointer;

        @media (max-width: 768px) {
            min-height: 36px;
            padding: 2px;
        }
    }

    .fc-daygrid-day-number {
        width: 100%;
    }
    .fc-daygrid-day-top {
        width: 100%;
    }

    /* Dia de hoje */
    .fc-day-today {
        background-color: #f0faf9 !important;
    }

    .celula-dia {
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 100%;
        gap: 4px;
    }

    .numero-dia {
        font-weight: 500;
        font-size: 0.85rem;
        color: #444;
    }

    /* Dia selecionado */
    .dia-selecionado {
        .numero-dia {
            background-color: #006a61;
            color: white;
            border-radius: 50%;
            width: 28px;
            height: 28px;
            display: flex;
            align-items: center;
            justify-content: center;
            font-weight: 600;
        }
    }

    /* Tracinho verde indicador de evento */
    .evento-indicador {
        width: 18px;
        height: 4px;
        border-radius: 2px;
        background-color: #006a61;
    }
`;
